import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { getMonthName } from "../General/Utility";

const RoutesPrint = () => {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(
        localStorage.getItem("MemberType")
    );
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [ReportMonth, setReportMonth] = useState("");
    const [ReportYear, setReportYear] = useState("");
    const [summary, setSummary] = useState({
        TransportStudents: 0,
        FeePostedStudents: 0,
        PaidStudents: 0,
        TotalPostedFee: 0,
        TotalReceiveableFee: 0,
        TotalReceivedAmount: 0,
        TotalPendingFee: 0,
        TotalConcessionAmount: 0,
    });

    useEffect(() => {
        document.title = "School Management System";

        setLoading(true);
        const urlParams = new URLSearchParams(window.location.search);

        const reportYear = urlParams.get("ReportYear");
        const reportMonth = urlParams.get("ReportMonth");
        const wingId = urlParams.get("Wing_Id") || 0;
        const classId = urlParams.get("Class_Id") || 0;
        const sectionId = urlParams.get("Section_Id") || 0;
        const routeId = urlParams.get("RouteID") || 0;

        setReportYear(reportYear);
        setReportMonth(reportMonth);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: 1,
            pageSize: 10000,
            ReportYear: reportYear,
            ReportMonth: reportMonth,
            Wing_Id: wingId,
            Class_Id: classId,
            Section_Id: sectionId,
            AccountLevel: routeId,
        };

        var api_config = {
            method: "post",
            url: config.base_url + "/Reports/GetRoutesReport",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords || []);
                    setSummary({
                        TransportStudents: response.data.TransportStudents || 0,
                        FeePostedStudents: response.data.FeePostedStudents || 0,
                        PaidStudents: response.data.PaidStudents || 0,
                        TotalPostedFee: response.data.TotalPostedFee || 0,
                        TotalReceiveableFee: response.data.TotalReceiveableFee || 0,
                        TotalReceivedAmount: response.data.TotalReceivedAmount || 0,
                        TotalPendingFee: response.data.TotalPendingFee || 0,
                        TotalConcessionAmount: response.data.TotalConcessionAmount || 0,
                    });
                }
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
            });
    }, []);

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            return listOfLedger.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{item.Status_Type_Id}</td>
                        <td>{item.Registration_No}</td>
                        <td>{item.Student_Name}</td>
                        <td>{item.SelectedClass.Class_Name} - {item.SelectedClass.Class_Code}</td>
                        <td>{item.BusRoute}</td>
                        <td>{item.Route_Code}</td>
                        <td>{item.BusAvailDays > 0 ? `${item.BusAvailDays}/${item.BusMonthlyDays}` : "—"}</td>
                        <td>{item.FeePosted}</td>
                        <td>{item.ConcessionAmount}</td>
                        <td>{item.ReceiveableFee}</td>
                        <td>{item.ReceivedAmount}</td>
                        <td>{item.PendingFee}</td>
                        <td>{item.PaymentStatus || "—"}</td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="13">
                        <h4
                            className="mt-3"
                            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
                        >
                            No transport students found
                        </h4>
                    </td>
                </tr>
            );
        }
    };

    return (
        <>
            <Page orientation="portrait" size="a4">
                <table className="table table-sm table-bordered table-print">
                    <thead>
                        <tr>
                            <th colSpan={13}>
                                <PrintHeader
                                    title={`Transport Routes Report — ${getMonthName(
                                        ReportMonth
                                    )} ${ReportYear}`}
                                />
                            </th>
                        </tr>
                        {!loading && (
                            <tr>
                                <th colSpan={13} className="text-center" style={{ fontSize: "12px" }}>
                                    Transport students: {summary.TransportStudents} | Fee posted: {summary.FeePostedStudents} | Paid: {summary.PaidStudents} | Receivable: {summary.TotalReceiveableFee}
                                </th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td className="text-center" colSpan="13">
                                    <Spinner animation="border" role="status"></Spinner>
                                </td>
                            </tr>
                        ) : (
                            <>
                                <tr>
                                    <th>Sr. No</th>
                                    <th>Registration No</th>
                                    <th>Student Name</th>
                                    <th>Class</th>
                                    <th>Bus Route</th>
                                    <th>Route Code</th>
                                    <th>Bus Days</th>
                                    <th>Fee Posted</th>
                                    <th>Concession</th>
                                    <th>Receivable</th>
                                    <th>Received</th>
                                    <th>Pending</th>
                                    <th>Status</th>
                                </tr>
                                {renderLedger()}
                                {listOfLedger.length > 0 && (
                                    <tr>
                                        <td colSpan={7}><b>Total</b></td>
                                        <td><b>{summary.TotalPostedFee}</b></td>
                                        <td><b>{summary.TotalConcessionAmount}</b></td>
                                        <td><b>{summary.TotalReceiveableFee}</b></td>
                                        <td><b>{summary.TotalReceivedAmount}</b></td>
                                        <td><b>{summary.TotalPendingFee}</b></td>
                                        <td></td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </Page>
        </>
    );
};

export default RoutesPrint;
